import { DeleteOutlined, EditOutlined, PlusOutlined } from "@ant-design/icons";
import { Button, Flex, Modal, Spin, Tooltip, Typography } from "antd";
import { useForm } from "antd/lib/form/Form";
import _ from "lodash";
import React, { useState } from "react";
import { useTranslation } from "react-i18next";
import { useGetDataOnScroll } from "../../../../components/getDataOnScrollProps/useGetDataOnScrollProps";
import { useWinterCerealFertilizer } from "./useWinterCerealFertilizer";
import { FilterWinterCerealFertilizer } from "./FilterWinterCerealFertilizer";
import { ContentPartFilter } from "../../../../components/content-part/ContentPartFilter";
import { PageHeader } from "../../../../components/page-header";
import { AddWinterCerealFertilizer } from "./AddWinterCerealFertilizer";
import { EntWinterCerealFertilizer } from "../../../../models/chemicalization/winterCerealFertilizer";
import { EntWinterCerealFertilizerFilter } from "../../../../models/filters/winterCerealFertilizerFilter";
import {
  useLazyGetWinterCerealFertilizerListQuery,
  useReportWinterCerealFertilizerMutation
} from "../../../../redux/api/chemicalization/winterCerealFertilizer";
import i18n from "i18next";
import ReportChemicalization from "../reportChemicalization/ReportChemicalization";


enum FormField {
  periodStart,
  periodEnd,
  territorialUnitIds,
}

export const WinterCerealFertilizer = () => {
  const [modal, contextHolder] = Modal.useModal();
  const [selectedFarmOwner, setSelectedFarmOwner] = useState<EntWinterCerealFertilizer>(new EntWinterCerealFertilizer());
  const [showModal, setShowModal] = useState<boolean>(false);
  const [form] = useForm();
  const { t } = useTranslation()
  const [showReportModal, setShowReportModal] = useState<boolean>(false);

  const [getReportWinterCerealFertilizer] = useReportWinterCerealFertilizerMutation();
  const [getArchiveFolders] = useLazyGetWinterCerealFertilizerListQuery();
  const {
	filter,
	fetching,
	data,
	access,
	totalItems,
	setData,
	setFetching,
	setFilter,
	scrollHandler,
	setCurrentPage
  } = useGetDataOnScroll<EntWinterCerealFertilizer, EntWinterCerealFertilizerFilter>({
	initialFilter: new EntWinterCerealFertilizerFilter(),
	query: getArchiveFolders
  });

  const {
	onAddWinterCerealFertilizer,
	onDeleteWinterCerealFertilizer,
	onEditWinterCerealFertilizer
  } = useWinterCerealFertilizer(modal, () => {
	searchHandleClick();
  })

  const [height, setHeight] = useState<number>(0);

  const storedData = JSON.parse(localStorage.getItem("availableRoutes") || "[]");
  const isChemAvailable = storedData.some((route: any) => (route.alias === "/departments/chemicalization/report" || route.alias === "/interactive-map-ws") && route.methodPost);

  const openAddModal = (item: EntWinterCerealFertilizer) => {
	setSelectedFarmOwner(item);
	setShowModal(true);
  }

  const setEntityFromFields = (): EntWinterCerealFertilizerFilter => {
	let filt: EntWinterCerealFertilizerFilter = _.clone(filter);
	filt.periodStart = form.getFieldValue(FormField.periodStart)?.format("YYYY-MM-DD") ?? null;
	filt.periodEnd = form.getFieldValue(FormField.periodEnd)?.format("YYYY-MM-DD") ?? null;
	filt.territorialUnitIds = form.getFieldValue(FormField.territorialUnitIds) ?? null;
	filt.page = 1;
	return filt;
  }
  const clearFields = () => {
	form.setFields([
	  { name: FormField.periodStart, value: null },
	  { name: FormField.periodEnd, value: null },
	  { name: FormField.territorialUnitIds, value: null },
	]);
  }
  const searchHandleClick = () => {
	setFilter(setEntityFromFields());
	setData([]);
	setCurrentPage(0);
	setFetching(true);
  }

  const getReport = async (payload: { periodStart: string; periodEnd: string; language: string }): Promise<Blob> => {
	return await getReportWinterCerealFertilizer(payload).unwrap();
  };

  const openReportModal = () => {
	setShowReportModal(true);
  };

  const table = (
	<div style={ { maxHeight: `${ height }px`, overflow: 'auto', maxWidth: 1600 } } onScroll={ scrollHandler }>
	  <table>
		<thead>
		<tr>
		  <th style={ { width: "40px" } }>#</th>
		  <th style={ { width: "90px" } }>{ t('titles.territorialUnitRegion') }</th>

		  <th>{ t('titles.territorialUnitDistricts') }</th>
		  <th style={ { width: "110px" } }>{ t('chemicalization.winter_cereal_fertilizer.neededPKg') }</th>
		  <th style={ { width: "110px" } }>{ t('chemicalization.winter_cereal_fertilizer.neededKKg') }</th>
		  {/*<th style={ { width: "70px" } }>{ t('chemicalization.winter_cereal_fertilizer.totalNeededKg') }</th>*/ }
		  <th>{ t('chemicalization.winter_cereal_fertilizer.factSownArea') }</th>
		  {/*<th>{ t('chemicalization.winter_cereal_fertilizer.fertilizedArea') }</th>*/ }
		  {/*<th>{ t('chemicalization.winter_cereal_fertilizer.fertilizationPercent') }</th>*/ }
		  <th>{ t('chemicalization.winter_cereal_fertilizer.totalSownArea') }</th>
		  <th>{ t('chemicalization.winter_cereal_fertilizer.deliveredPKg') }</th>
		  <th>{ t('chemicalization.winter_cereal_fertilizer.deliveredKKg') }</th>
		  {/*<th>{ t('chemicalization.winter_cereal_fertilizer.totalDelivered') }</th>*/ }
		  <th>{ t('chemicalization.winter_cereal_fertilizer.availabilityPK') }</th>
		  <th style={ { width: "120px" } }></th>
		</tr>
		</thead>
		<tbody>
		{ fetching ?
		  <tr>
			<th colSpan={ 5 }>
			  <Spin spinning={ fetching } style={ {
				width: '100%',
				height: '180px',
				display: 'flex',
				alignItems: 'center',
				justifyContent: 'center'
			  } }/>
			</th>
		  </tr>
		  : <></> }
		{ data.map((item, index) => (
		  <tr key={ item.id }>
			<td>{ ++index }</td>
			<td>{ i18n.language === 'ru' ? item?.territorialUnit?.nameRu : item?.territorialUnit?.nameKy }</td>

			<td>
			  <div className="chem-detail" style={ { gap: '40px' } }>
				{ item?.winterCerealFertilizerDetails?.map((detail) => (
				  <div key={ detail.id }>
					{ i18n.language === 'ru' ? detail?.territorialUnitDistrict?.nameRu : detail?.territorialUnitDistrict?.nameKy }
				  </div>
				)) }
			  </div>
			</td>
			<td>
			  <div className="chem-detail" style={ { gap: '40px' } }>
				{ item?.winterCerealFertilizerDetails?.map((detail) => (
				  <div key={ detail.id }>
					{ detail.neededPKg }
				  </div>
				)) }
			  </div>
			</td>
			<td>
			  <div className="chem-detail" style={ { gap: '40px' } }>
				{ item?.winterCerealFertilizerDetails?.map((detail) => (
				  <div key={ detail.id }>
					{ detail.neededKKg }
				  </div>
				)) }
			  </div>
			</td>
			{/*<td>*/ }
			{/*  <div className="fertilizer-cell" style={ { gap: '40px' } }>*/ }
			{/*	{ item?.winterCerealFertilizerDetails?.map((detail) => (*/ }
			{/*	  <div key={ detail.id }>*/ }
			{/*		{ detail.totalNeededKg }*/ }
			{/*	  </div>*/ }
			{/*	)) }*/ }
			{/*  </div>*/ }
			{/*</td>*/ }
			<td>
			  <div className="chem-detail" style={ { gap: '40px' } }>
				{ item?.winterCerealFertilizerDetails?.map((detail) => (
				  <div key={ detail.id }>
					{ detail.factSownArea }
				  </div>
				)) }
			  </div>
			</td>
			{/*<td>*/ }
			{/*  <div className="fertilizer-cell" style={ { gap: '40px' } }>*/ }
			{/*	{ item?.winterCerealFertilizerDetails?.map((detail) => (*/ }
			{/*	  <div key={ detail.id }>*/ }
			{/*		{ detail.fertilizedArea }*/ }
			{/*	  </div>*/ }
			{/*	)) }*/ }
			{/*  </div>*/ }
			{/*</td>*/ }
			{/*<td>*/ }
			{/*  <div className="fertilizer-cell" style={ { gap: '40px' } }>*/ }
			{/*	{ item?.winterCerealFertilizerDetails?.map((detail) => (*/ }
			{/*	  <div key={ detail.id }>*/ }
			{/*		{ Number(detail.fertilizationPercent).toFixed(3) }*/ }
			{/*	  </div>*/ }
			{/*	)) }*/ }
			{/*  </div>*/ }
			{/*</td>*/ }
			<td>
			  <div className="chem-detail" style={ { gap: '40px' } }>
				{ item?.winterCerealFertilizerDetails?.map((detail) => (
				  <div key={ detail.id }>
					{ detail.totalSownArea }
				  </div>
				)) }
			  </div>
			</td>
			<td>
			  <div className="chem-detail" style={ { gap: '40px' } }>
				{ item?.winterCerealFertilizerDetails?.map((detail) => (
				  <div key={ detail.id }>
					{ detail.deliveredPKg }
				  </div>
				)) }
			  </div>
			</td>
			<td>
			  <div className="chem-detail" style={ { gap: '40px' } }>
				{ item?.winterCerealFertilizerDetails?.map((detail) => (
				  <div key={ detail.id }>
					{ detail.deliveredKKg }
				  </div>
				)) }
			  </div>
			</td>
			{/*<td>*/ }
			{/*  <div className="fertilizer-cell" style={ { gap: '40px' } }>*/ }
			{/*	{ item?.winterCerealFertilizerDetails?.map((detail) => (*/ }
			{/*	  <div key={ detail.id }>*/ }
			{/*		{ detail.totalDelivered }*/ }
			{/*	  </div>*/ }
			{/*	)) }*/ }
			{/*  </div>*/ }
			{/*</td>*/ }
			<td>
			  <div className="chem-detail" style={ { gap: '40px' } }>
				{ item?.winterCerealFertilizerDetails?.map((detail) => (
				  <div key={ detail.id }>
					{ Number(detail.availabilityPK).toFixed(3) }
				  </div>
				)) }
			  </div>
			</td>
			<td>
			  <Flex gap="small">
				{ access && access.methodPut && (
				  <Tooltip title={ t('general.edit') }>
					<Button
					  className="btn_edit"
					  onClick={ () => {
						openAddModal(item);
					  } }
					  type="primary"
					  shape="circle"
					  icon={ <EditOutlined/> }
					/>
				  </Tooltip>
				) }
				{ access && access.methodDelete && (
				  <Tooltip title={ t('general.delete') }>
					<Button
					  className="btn_edit"
					  danger
					  onClick={ () => {
						onDeleteWinterCerealFertilizer(item);
					  } }
					  type="primary"
					  shape="circle"
					  icon={ <DeleteOutlined/> }
					/>
				  </Tooltip>
				) }
			  </Flex>
			</td>
		  </tr>
		)) }
		</tbody>
	  </table>
	</div>
  );
  return (
	<>
	  <PageHeader
		title={ t('titles.winter_cereal_fertilizer') }
		additionalInfo={
		  <Typography.Text style={ { marginBottom: '0.5em', display: 'block' } }
						   type="secondary"> { t('general.records_found') } { totalItems }</Typography.Text>
		}/>
	  { access && access.methodPost && (
		<Button type="primary" icon={ <PlusOutlined/> } onClick={ () => {
		  openAddModal(new EntWinterCerealFertilizer)
		} }>
		  { t('general.add') }
		</Button>
	  ) }
	  { isChemAvailable && (
		<Button style={ { marginLeft: '5px' } } type="primary" icon={ <PlusOutlined/> }
				onClick={ () => openReportModal() }>
		  { t('general.generate_report') }
		</Button>
	  ) }
	  <ContentPartFilter
		filter={ <FilterWinterCerealFertilizer onSearch={ searchHandleClick }
											   onReset={ () => {
												 clearFields();
												 searchHandleClick()
											   } } formField={ FormField } form={ form }/> }
		setHeight={ setHeight }
		table={ table }

	  />
	  <AddWinterCerealFertilizer
		winterCerealFertilizer={ selectedFarmOwner }
		show={ showModal }
		onHide={ () => {
		  setShowModal(false)
		} }
		onSubmit={ selectedFarmOwner.id !== null ? onEditWinterCerealFertilizer : onAddWinterCerealFertilizer }
	  />
	  <ReportChemicalization
		title={ t('reports.report_by_winter_cereals') }
		getReport={ getReport }
		show={ showReportModal }
		onHide={ () => setShowReportModal(false) }
	  />
	  { contextHolder }
	</>
  )
}
